/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export enum LicenceTypesEnum {
    TRIAL = 'trial',
    FULL = 'full',
    NFR = 'nfr'
}
